import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";

export const getImageUrlUsingIsbn = async ({isbn}) => {
    const token = getTokenFromSession()
    try {
        return await axiosInstance.get(`${api.image}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {
                isbn
            }
        })
    } catch (error) {
        console.error("Error fetching image:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", "/search");
            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await getImageUrlUsingIsbn({isbn});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        } else {
            alert("Image not found");
        }
    }
}

export const saveImageDetails = async ({imageDetails, isbn}) => {
    const token = getTokenFromSession()
    try {
        return await axiosInstance.post(`${api.image}`, imageDetails, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {
                isbn
            }
        })
    } catch (error) {
        console.error("Error fetching image:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", "/search");
            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await saveImageDetails({imageDetails, isbn});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}